import React from 'react'
import { Icon } from "@iconify/react/dist/iconify.js";
import DropdownProfile from './DropdownProfile';
import DropdownNotification from './DropdownNotification';

export const NavBar = ({mobileMenuControl,sidebarControl,sidebarActive}) => {
    return (
        <div className="navbar-header navbar-header-layered">
          <div className="row align-items-center justify-content-between">
            <div className="col-auto">
              <div className="d-flex flex-wrap align-items-center gap-4">
                <button type="button" className="sidebar-toggle" onClick={sidebarControl}>
                  {
                    sidebarActive ? (<Icon
                      icon="iconoir:arrow-right"
                      className="icon text-2xl non-active"
                    />) : (<Icon
                      icon="heroicons:bars-3-solid"
                      className="icon text-2xl non-active "
                    />)
                  }
                </button>
                <button onClick={mobileMenuControl} type="button" className="sidebar-mobile-toggle">
                  <Icon
                    icon="heroicons:bars-3-solid"
                    className="icon"
                  />
                </button>
                {/* <form className="navbar-search">
                  <input type="text" name="search" placeholder="Search" />
                  <Icon icon="ion:search-outline" className="icon" />
                </form> */}
              </div>
            </div>
            <div className="col-auto">
              <div className="d-flex flex-wrap align-items-center gap-3">
                <DropdownNotification/>
                <DropdownProfile/>
                {/* Profile dropdown end */}
              </div>
            </div>
          </div>
        </div>
    );
}
